import { Box, Button, Flex, Progress, Text } from '@chakra-ui/react';
import ModalTemplate from '@components/modalTemplate';
import { CloseIcon, ProcessingStateImage } from '@assets/icons';
import { useEffect } from 'react';
import { useEditDetail } from '@pages/ConsumerPromotion/hooks/state/useEditDetail';
import { useDownload } from '@pages/ConsumerPromotion/utils/useDownload';
import { useDownloadStore } from '@hooks/useDownloadStore';

function ModalDownloadDataClaim() {
    const stateEdit = useEditDetail();
    const { cancelDownload } = useDownload();
    const { progress } = useDownloadStore.getState();

    const onCloseHandler = () => {
        stateEdit.set({ claimPromo: null });
    };

    const handleCancelClaim = () => {
        cancelDownload();
        onCloseHandler();
    };

    useEffect(() => {
        onCloseHandler();
    }, []);

    return (
        <ModalTemplate
            isOpen={stateEdit.claimPromo}
            width={'546px'}
            onClose={onCloseHandler}
            isClosebyOverlayClick={false}
        >
            <Box p={'12px 12px 28px'}>
                <Box px={'40px'} textAlign={'center'} position={'relative'}>
                    <Button
                        variant={'unstyled'}
                        position={'absolute'}
                        right={'0'}
                        onClick={() =>
                            stateEdit.set({
                                claimPromo: {
                                    ...stateEdit.claimPromo,
                                    isCancel: true,
                                },
                            })
                        }
                    >
                        <CloseIcon />
                    </Button>

                    <Flex justifyContent={'center'}>
                        <ProcessingStateImage />
                    </Flex>

                    <Text fontWeight={'600'} fontSize={'sm'}>
                        Download Promotion Documents
                    </Text>

                    <Box textAlign="center" my={'40px'}>
                        <Progress value={progress} size="sm" mb="12px" isAnimated />
                        <Flex justifyContent="space-between" mb={'18px'}>
                            <Text>Sedang mengumpulkan data ...</Text>
                            <Text fontWeight={700}>{progress}%</Text>
                        </Flex>
                    </Box>

                    {stateEdit?.claimPromo?.isCancel ? (
                        <Flex justifyContent={'center'} gap={'12px'}>
                            <Button
                                variant={'outline'}
                                p={'12px 46px !important'}
                                onClick={() =>
                                    stateEdit.set({
                                        claimPromo: {
                                            ...stateEdit.claimPromo,
                                            isCancel: false,
                                        },
                                    })
                                }
                            >
                                Kembali
                            </Button>
                            <Button onClick={handleCancelClaim} p={'12px 46px !important'}>
                                Ya, Batal
                            </Button>
                        </Flex>
                    ) : (
                        <Button
                            variant={'outline'}
                            onClick={() =>
                                stateEdit.set({
                                    claimPromo: {
                                        ...stateEdit.claimPromo,
                                        isCancel: true,
                                    },
                                })
                            }
                        >
                            Batalkan Download
                        </Button>
                    )}
                </Box>
            </Box>
        </ModalTemplate>
    );
}

export default ModalDownloadDataClaim;
